import React, {useState} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import { useDispatch } from 'react-redux';
import { setUser } from './userSlice';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAuthStatus } from '../../request/Auth/authSlice';
import { Container, Alert, InputAdornment } from '@mui/material';
import { Email, ArrowForward, LockReset } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Styled components for better visual hierarchy
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '16px',
  boxShadow: theme.palette.mode === 'dark' 
    ? '0 8px 32px rgba(0, 0, 0, 0.4)' 
    : '0 8px 32px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(10px)',
  border: theme.palette.mode === 'dark' 
    ? '1px solid rgba(255, 255, 255, 0.1)' 
    : '1px solid rgba(255, 255, 255, 0.8)',
  background: theme.palette.mode === 'dark' 
    ? 'linear-gradient(135deg, rgba(30, 30, 30, 0.9), rgba(20, 20, 20, 0.9))' 
    : 'linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.9))',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  padding: '12px 24px',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  background: 'linear-gradient(135deg, #F7A600 0%, #FFB52E 100%)',
  boxShadow: '0 4px 15px rgba(247, 166, 0, 0.4)',
  '&:hover': {
    background: 'linear-gradient(135deg, #E69500 0%, #F7A600 100%)',
    boxShadow: '0 6px 20px rgba(247, 166, 0, 0.6)',
  },
}));

const StyledInput = styled(OutlinedInput)(({ theme }) => ({
  borderRadius: '12px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
    borderWidth: '2px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#F7A600',
    borderWidth: '2px',
  },
}));

const Forgot = () => {
    const dispatch = useDispatch();
    const initialLogin = {
        email: '',
    }
    const appMode = useSelector((state) => state.mode.mode);
    const redirectTo = useSelector((state) => state.redirect.redirect);
    const navigate = useNavigate();

    const [error, setErros] = useState('');
    const [registerForm, setRegisterForm] = useState(initialLogin);
    
    const onChange = (e) =>
    setRegisterForm({ ...registerForm, [e.target.name]: e.target.value });

    const { isLoading: isSendingRequest, mutate: postLogin } = useMutation(

        async () => {
          return await apiClient.post(`/api/forgot-password`, {
            email: registerForm.email,
          });
        },
        {
          onSuccess: (res) => {            
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            navigate('/update-password');
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.message) 
            const event2 = new Event('processed');
            window.dispatchEvent(event2);      
          },
        }
      );
      const onSubmit = async() =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postLogin();
      } 

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        background: appMode === 'dark' 
          ? 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)'
          : 'linear-gradient(135deg, #F7A600 0%, #FFB52E 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: '10px', sm: '15px', md: '20px' }
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        <StyledCard sx={{ maxWidth: '600px', mx: 'auto' }}>
          <CardContent sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
            {/* Logo Section */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <img  
                src={appMode === 'dark'? '/logos/imex-light-logo.png' : '/logos/imex-dark-logo.png'} 
                style={{height: '60px', marginBottom: '16px'}} 
                alt="IMEXS BROKERAGE Logo" 
              />
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                mb: 2,
                color: '#F7A600'
              }}>
                <LockReset sx={{ fontSize: '48px', mr: 2 }} />
              </Box>
              <Typography 
                variant="h4" 
                sx={{ 
                  fontWeight: 700, 
                  background: 'linear-gradient(135deg, #F7A600 0%, #FFB52E 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 1
                }}
              >
                Reset Password
                    </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '16px',
                  maxWidth: '400px',
                  mx: 'auto'
                }}
              >
                Enter your email address and we'll send you a verification code to reset your password
                    </Typography>
            </Box>

            {/* Error Alert */}
            {error && (
              <Alert 
                severity="error" 
                sx={{ 
                  mb: 3, 
                  borderRadius: '12px',
                  '& .MuiAlert-icon': { fontSize: '20px' }
                }}
              >
                {error}
              </Alert>
            )}

            {/* Form Fields */}
            <Box sx={{ mb: 4 }}>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel 
                  htmlFor="email"
                  sx={{ 
                    color: 'text.secondary',
                    '&.Mui-focused': { color: '#F7A600' }
                  }}
                >
                  Email Address
                </InputLabel>
                <StyledInput
                  error={error !== ''}
                            onChange={onChange}
                            id="email"
                  type="email"
                            name="email"
                  label="Email Address"
                  startAdornment={
                    <InputAdornment position="start">
                      <Email sx={{ color: 'text.secondary', fontSize: '20px' }} />
                    </InputAdornment>
                             }
                />
                        </FormControl>
            </Box>

            {/* Submit Button */}
            <StyledButton
              onClick={onSubmit}
              fullWidth
              size="large"
              variant="contained"
              disabled={isSendingRequest}
              endIcon={isSendingRequest ? null : <ArrowForward />}
              sx={{ 
                height: '56px',
                fontSize: '16px',
                fontWeight: 600,
                mb: 4
              }}
            >
              {isSendingRequest ? 'Sending Code...' : 'Send Verification Code'}
            </StyledButton>
                        
            {/* Action Links */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              mb: 3
            }}>
              <Link 
                component={RouterLink} 
                to='/login' 
                underline="none"
                sx={{ 
                  color: '#F7A600',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Back to Login
                            </Link>
              <Link 
                component={RouterLink} 
                to='/register' 
                underline="none"
                sx={{ 
                  color: '#F7A600',
                  fontWeight: 500,
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Create Account
                            </Link>
                        </Box>

            {/* Footer */}
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '14px'
                }}
              >
                Need help? Contact our support team
              </Typography>
            </Box>
                    </CardContent>
        </StyledCard>
      </Container>
    </Box>
  )
}

export default Forgot
